import { useCallback, useContext, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { ConferenceContext } from 'contexts/conference'
import { ChatBot } from 'chat-bot'

interface ConfigOptions {
    userToken: string
    firstName: string
    currentLevel: string
    envType: string
    appName: string
}

interface UserState {
    firstName: string
}

const ChatPortal = (): React.ReactPortal | null => {
    const chatRoot = document.getElementById('react-root-chat')
    if (!chatRoot) return null

    const conference = useContext(ConferenceContext)
    const [userState, setUserState] = useState<UserState | null >(null)
    const [currentLevel, setCurrentLevel] = useState<string>('')
    const getCookieValue = useCallback((name: string): string => {
        return (
            document.cookie.split(';').map(c => c.trim()).find(row => row.startsWith(`${name}=`))?.split('=')[1] || ''
        )
    }, [])
    useEffect(() => {
        if (conference.status === 'session-joined') {
            const currentUser = conference?.chatClient?.getCurrentUser() || {}
            setUserState(currentUser)
            const levelFromCookie = getCookieValue('studentCurrentLevel')
            if (levelFromCookie) {
                const levelNumber = levelFromCookie.replace(/^L/, '')
                setCurrentLevel(levelNumber)
            } else {
                console.warn('Level cookie is not set or invalid')
            }
        }
    }, [conference.status, getCookieValue])

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const styledContainer = document.querySelector('#react-root-chat div div[data-testid="styled-container"]') as HTMLElement
            if (styledContainer) {
                styledContainer.style.zIndex = '2'
                styledContainer.style.marginRight = '12px'
                observer.disconnect()
            }
        })

        observer.observe(document.body, { childList: true, subtree: true })

        return () => observer.disconnect()
    }, [])

    const getConfigOptions = (): ConfigOptions => {
        const rawToken = sessionStorage.getItem('auth') || ''
        const userToken = rawToken.replace(/^Bearer\s+/i, '')
        const firstName: string = userState?.firstName || ''
        const envType: string = String(process.env.REACT_APP_ENV) || 'qual'

        return {
            userToken,
            firstName,
            currentLevel,
            envType,
            appName: 'goc-classroom'
        }
    }

    if (!userState) {
        return null
    }

    const configOptions = getConfigOptions()
    return createPortal(
        <ChatBot configOptions={configOptions} />,
        chatRoot
    )
}

export default ChatPortal
